import { Text, View, Image } from 'components';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';
import cx from 'classnames'


interface State {
  options: any[];
}

export default class Vip extends Base<any, State>  {
  public config: Config = {
    navigationBarTitleText: '替班包月卡'
  };

  public state: State = {
    options: [{
      bgImage: this.assets.megatron.tibanItemBg1,
      desc: '<24小时内电话随便打>',
      info: null
    }, {
      bgImage: this.assets.megatron.tibanItemBg2,
      desc: '<有效期为30天>',
      tag: '额外再送90积分',
      info: null
    }],
  };


  public async didMount() {
    await this.getUserInfo();
    this.fetchRechargeList()
  }

  public render() {
    const { options } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        
        
        <View className={styles.head}>
          <View className={styles.h2}>
            <Image src={this.assets.megatron.alermTiban} className={styles.ico} />温馨提示：
          </View>
          {/* <Text className={styles.p}>1、工机管家平台的长期工作一直是免费拨打</Text> */}
          <Text className={styles.p}>1、【替班】工作因为时效性太快，打的人过多，所以设置一个小门槛，谢谢大家的理解支持</Text>
        </View>
        <View className={styles.main}>
          <View className={styles.title}>
            <Text className={styles.h2}>替班活仅限办卡客户联系</Text>
            <Image src={this.assets.megatron.arrDownDouble} className={styles.ico} />
          </View>
          <View className={styles.tabs}>
            {options.map((res, ind) => (
              <View className={this.cx(styles.item, styles['item'+ind])} onClick={this.handleTibanPurchase.bind(null, res.info)}>
                <View className={styles.tabItem} style={{backgroundImage: 'url('+res.bgImage+')'}}>
                  <View className={styles.up}>
                    <View className={styles.tit}>
                      {res.info? res.info.name: ''}
                    </View>
                    <View className={styles.desc}>{res.desc}</View>
                  </View>
                  <View className={styles.down}>
                    <Text className={styles.h2}><Text className={styles.sm}>￥</Text>{res.info? Number(res.info.price): 0}</Text>
                    <View className={styles.p}>
                      {ind == 0 && <Text className={styles.red}>(不能打长期)</Text>}
                      <Text>{'点此开通 >>'}</Text>
                    </View>
                  </View>
                  {res.tag && <View className={styles.tag}>{res.tag}</View>}
                  {ind == 1 && 
                    <Image src={this.assets.megatron.recommendTiban} className={styles.recommend} />
                  }
                </View>
              </View>
            ))}
          </View>
        </View>

        
      </View>
    );
  }


  private getUserInfo = async () => {
    const { body } = await this.apiClient.base.userinfo();

    if( body ) {
      
    }
    
  }

  private fetchRechargeList = async () => {
    let { options } = this.state
    const { body } = await this.apiClient.base.scoresRechargeList({type: 9});

    options.map((res, ind) => {
      res.info = body[ind]
    })
    this.setState({
      options: [...options]
    });
    
  }

  

  private handleTibanPurchase = async(info) => {
    let id = info.id
    if(!id){
      toast.error('获取ID失败！',{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }

    const response = await this.apiClient.base.purchaseScores({
      id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        toast.success('购买成功！',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
      }
    }).catch(err => {
      console.log(err)
      toast.error('付款失败！',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
    });


    
  }

}
